<template>
    <sections class="page-cookies">
        <section-text heading="Cookies" content="<article-cookies />"></section-text>
        <section-text v-if="cookies.asked" padding="pb-12 sm:pb-14">
            <template v-slot:custom>
                <form-switch-block
                    heading="Necessary Cookies"
                    content="<article-cookies-necessary />"
                    noSwitchText="Required"
                ></form-switch-block>
                <form-switch-block
                    heading="Analytical Cookies"
                    content="<article-cookies-analytical />"
                    field="analytic"
                    :value="cookies.analytic"
                    :toggle="toggleCookies"
                ></form-switch-block>
            </template>
        </section-text>
        <section-text
            color="bg-zinc-50"
            heading="What Are Cookies?"
            content="<article-cookies-what-are />"
        ></section-text>
    </sections>
</template>

<script setup>
const {cookies} = storeToRefs(useStoreCookies());
const {toggleCookies} = useStoreCookies();

const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Cookies | ' + $config.public.siteName,
    description: 'Learn about our cookie policy.',
    index: false,
});
</script>
